import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { createIconComponent } from 'uikit/icons';

import Typo from 'uikit/content/components/typo';

import styles from '../styles/uikitLabelsLabel.module.scss';

const CLASSES = {
  type: {
    default: styles.isTypeDefault,
    brand: styles.isTypeBrand,
    live: styles.isTypeLive,
    outlined: styles.isTypeOutlined,
    success: styles.isTypeSuccess,
    warning: styles.isTypeWarning,
  },
};

const Label = ({
  className = '',
  icon = '',
  modifier = '',
  testId = '',
  text,
  type = 'default',
  variant = 's01',
}) => (
  <div
    className={classnames(styles.element, { [CLASSES.type[type]]: type }, className)}
    data-testid={testId}
  >
    {type === 'live' && <span className={styles.iconLiveNow} aria-hidden />}
    {icon && <span className={styles.icon}>{createIconComponent({ icon })}</span>}
    <Typo
      color="inherit"
      element="span"
      modifier={type === 'live' ? 'uppercase' : modifier}
      variant={variant}
      weight={type === 'live' ? undefined : 'medium'}
    >
      {text}
    </Typo>
  </div>
);

Label.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  modifier: PropTypes.string,
  testId: PropTypes.string,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['default', 'brand', 'live', 'outlined', 'success', 'warning']),
  variant: PropTypes.string,
};

export { Label as LabelStorybook };
export default memo(Label);
